export default __webpack_public_path__ + "static/media/agueroProfile.bc01d5bf.png";